import React from 'react'

const Header = () => {
  return (
    <header>
      {/* Block header */}
      <div className="app-header" id="">
        <div className="pre-header border-bottom">
          <div className="container">
            <div className="d-flex flex-row justify-content-end py-3">
              <div>
                <a href="#" className="py-1 border-0 px-4 btn btn-primary">
                  Nous contacter
                </a>
              </div>
              <div>
                <a href="#" className="py-1 px-4 btn btn-default">
                  Nous rejoindre
                </a>
              </div>
              <div className="border-end border-start d-sm-inline d-none">
                <a href="#" className="py-1 px-4 btn btn-default">
                  Notre Histoire
                </a>
              </div>
              <div className="d-sm-inline d-none">
                <a href="#" className="py-1 px-4 btn btn-default">
                  Nos Valeurs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
          <nav className="navbar fixed-nav navbar-expand-lg navbar-light bg-light-c flex-column">
            <div className="container">
              <div className="navbar-brand" href="#">
                <div className="d-flex">
                  {/* <a href="#">
                            <span class="fs-1 me-3">
                                <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="38" height="3" fill="#B39C81"/>
                                    <rect y="13" width="38" height="3" fill="#B39C81"/>
                                    <rect y="26" width="38" height="3" fill="#B39C81"/>
                                </svg>
                            </span>
                        </a>
                <a href="#"> */}
                  <div className="burger-menu">
                    <nav>
                      <input
                        type="checkbox"
                        id="menu"
                        name="menu"
                        className="m-menu__checkbox"
                      />
                      <label className="m-menu__toggle" htmlFor="menu">
                        <svg
                          width={35}
                          height={35}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#B39C81"
                          strokeWidth={2}
                          strokeLinecap="butt"
                          strokeLinejoin="arcs"
                        >
                          <line x1={3} y1={12} x2={21} y2={12} />
                          <line x1={3} y1={6} x2={21} y2={6} />
                          <line x1={3} y1={18} x2={21} y2={18} />
                        </svg>
                      </label>
                      <label className="m-menu__overlay" htmlFor="menu" />
                      <div className="m-menu except-overflow">
                        <div className="m-menu__header">
                          <label className="m-menu__toggle" htmlFor="menu">
                            <span className="fs-1 me-3">
                              <svg
                                width={35}
                                height={35}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#B39C81"
                                strokeWidth={2}
                                strokeLinecap="butt"
                                strokeLinejoin="arcs"
                              >
                                <line x1={18} y1={6} x2={6} y2={18} />
                                <line x1={6} y1={6} x2={18} y2={18} />
                              </svg>
                            </span>
                          </label>
                          <span className="mt-1">
                            <span>
                              <img
                                height={70}
                                src="/assets/images/logo-rullier-bois.png"
                                alt=""
                              />
                            </span>
                          </span>
                        </div>
                        <ul>
                          <li>
                            <label className="a-label__chevron" htmlFor="item-2">
                              Produits
                            </label>
                            <input
                              type="checkbox"
                              id="item-2"
                              name="item-2"
                              className="m-menu__checkbox"
                            />
                            <div className="m-menu except-overflow">
                              <div className="m-menu__header">
                                <label
                                  className="m-menu__toggle my-auto"
                                  htmlFor="item-2"
                                >
                                  <svg
                                    width={35}
                                    height={35}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#000000"
                                    strokeWidth={2}
                                    strokeLinecap="butt"
                                    strokeLinejoin="arcs"
                                  >
                                    <path d="M19 12H6M12 5l-7 7 7 7" />
                                  </svg>
                                </label>
                                <span className="my-auto">Produits</span>
                              </div>
                              <ul>
                                <li>
                                  <label>BOIS DE CONSTRUCTION </label>
                                </li>
                                <li>
                                  <label>AGENCEMENT</label>
                                </li>
                                <li>
                                  <label
                                    className="a-label__chevron"
                                    htmlFor="item-2-3"
                                  >
                                    TERRASSE &amp; EXTÉRIEUR
                                  </label>
                                  <input
                                    type="checkbox"
                                    id="item-2-3"
                                    name="item-2"
                                    className="m-menu__checkbox mega-menu"
                                  />
                                  <div className="m-menu mega-menu-wraper">
                                    <div className="overflow-wrapper">
                                      <div className="row">
                                        <div className="col-md-9">
                                          <div className="mega-content">
                                            <div className="m-menu__header">
                                              <label
                                                className="m-menu__toggle my-auto"
                                                htmlFor="item-2-3"
                                              >
                                                {/* <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="#B39C81" stroke-width="2" stroke-linecap="butt" stroke-linejoin="arcs">
                                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                                </svg> */}
                                              </label>
                                              <span className="my-auto">
                                                TERRASSE &amp; EXTÉRIEUR
                                              </span>
                                            </div>
                                            <ul className="menu-items columnList">
                                              <li className="level1 groups item nav-3-1 first">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique.html"
                                                >
                                                  <span>
                                                    Terrasses en bois exotique
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-1-1 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/ipe.html"
                                                      >
                                                        <span>Ipé</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-2">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/padouk.html"
                                                      >
                                                        <span>Padouk</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-3">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/cumaru.html"
                                                      >
                                                        <span>Cumaru</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-4">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/itauba.html"
                                                      >
                                                        <span>Itauba</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-5">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/massaranduba.html"
                                                      >
                                                        <span>Massaranduba</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-6">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/tatajuba.html"
                                                      >
                                                        <span>Tatajuba</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-1-7 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-exotique/bangkirai.html"
                                                      >
                                                        <span>Bangkirai</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 no-child groups item nav-3-2 active">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/dalles-bois-exotique.html"
                                                >
                                                  <span>Dalles Bois Exotique</span>
                                                </a>
                                              </li>
                                              <li className="level1 groups item nav-3-3">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-bambou.html"
                                                >
                                                  <span>Terrasse Bambou</span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-3-8 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-bambou/lames-terrasse-bambou.html"
                                                      >
                                                        <span>
                                                          Lames Terrasse Bambou
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-3-9 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-bambou/accessoires-bambou.html"
                                                      >
                                                        <span>
                                                          Accessoires Bambou
                                                        </span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-4">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-composite.html"
                                                >
                                                  <span>
                                                    Terrasses en bois composite
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-4-10 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-composite/lames-composite.html"
                                                      >
                                                        <span>Lames composite</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-4-11 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasses-bois-composite/accessoires.html"
                                                      >
                                                        <span>
                                                          Accessoires bois composite
                                                        </span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-5">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-kebony.html"
                                                >
                                                  <span>Terrasse Kebony</span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-5-12 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-kebony/kebony-pin-sylvestre.html"
                                                      >
                                                        <span>
                                                          Kebony Pin Sylvestre
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-5-13 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/terrasse-kebony/kebony-radiata.html"
                                                      >
                                                        <span>
                                                          Kebony Pin Radiata
                                                        </span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-6">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine.html"
                                                >
                                                  <span>
                                                    Bois de Nouvelle-Aquitaine
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 nav-3-6-14 first parent">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-traite-classe-4.html"
                                                      >
                                                        <span>
                                                          Terrasse en bois traité
                                                          classe 4
                                                        </span>
                                                        <i className="item-has-sub fa fa-caret-right" />
                                                      </a>
                                                      <div
                                                        className="level2 sub-wrapper"
                                                        style={{
                                                          height: "auto",
                                                          opacity: 1,
                                                          display: "none"
                                                        }}
                                                      >
                                                        <div className="list_item_dropdown clearfix">
                                                          <ul className="level2">
                                                            <li className="level3 no-child nav-3-6-14-1 first last">
                                                              <a
                                                                className=""
                                                                href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-traite-classe-4/pin-traite-classe-4.html"
                                                              >
                                                                <span>
                                                                  Pin traité classe
                                                                  4
                                                                </span>
                                                              </a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </li>
                                                    <li className="level2 nav-3-6-15 last parent">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-non-traite.html"
                                                      >
                                                        <span>
                                                          Terrasse en bois
                                                          non-traité
                                                        </span>
                                                        <i className="item-has-sub fa fa-caret-right" />
                                                      </a>
                                                      <div
                                                        className="level2 sub-wrapper"
                                                        style={{
                                                          height: "auto",
                                                          opacity: 1,
                                                          display: "none"
                                                        }}
                                                      >
                                                        <div className="list_item_dropdown clearfix">
                                                          <ul className="level2">
                                                            <li className="level3 no-child nav-3-6-15-2 first">
                                                              <a
                                                                className=""
                                                                href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-non-traite/terrasse-douglas.html"
                                                              >
                                                                <span>Douglas</span>
                                                              </a>
                                                            </li>
                                                            <li className="level3 no-child nav-3-6-15-3">
                                                              <a
                                                                className=""
                                                                href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-non-traite/acacia.html"
                                                              >
                                                                <span>Acacia</span>
                                                              </a>
                                                            </li>
                                                            <li className="level3 no-child nav-3-6-15-4 last">
                                                              <a
                                                                className=""
                                                                href="https://www.rullier.fr/terrasse-et-exterieurs/bois-de-nouvelle-aquitaine/terrasse-bois-non-traite/terrasse-feuillus-chene.html"
                                                              >
                                                                <span>Chêne</span>
                                                              </a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-7">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/lambourdes-bois-de-structure.html"
                                                >
                                                  <span>
                                                    Lambourdes - Bois de structure
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-7-16 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/lambourdes-bois-de-structure/bois-exotique.html"
                                                      >
                                                        <span>Bois exotique</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-7-17 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/lambourdes-bois-de-structure/pin-classe-4.html"
                                                      >
                                                        <span>Pin classe 4</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-8">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses.html"
                                                >
                                                  <span>
                                                    Accessoires de pose pour les
                                                    terrasses
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-8-18 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/plots-de-fixation.html"
                                                      >
                                                        <span>
                                                          Plots de fixation
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-8-19">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/vis-forets.html"
                                                      >
                                                        <span>
                                                          Vis &amp; forets
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-8-20">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/fixations-invisibles.html"
                                                      >
                                                        <span>
                                                          Fixations invisibles
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-8-21">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/cales.html"
                                                      >
                                                        <span>Cales</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-8-22">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/geotextile-bande-bitumeuse.html"
                                                      >
                                                        <span>
                                                          Géotextile / Bande
                                                          bitumeuse
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-8-23 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/accessoires-pose-pour-terrasses/vis-de-fondation-weasyfix.html"
                                                      >
                                                        <span>
                                                          Vis de fondation Weasyfix
                                                        </span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-9">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/amenagements-exterieurs.html"
                                                >
                                                  <span>
                                                    Aménagements extérieurs
                                                  </span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-9-24 first">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/amenagements-exterieurs/claustras.html"
                                                      >
                                                        <span>Claustras bois</span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-9-25">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/amenagements-exterieurs/claustras-composite.html"
                                                      >
                                                        <span>
                                                          Claustras composite
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-9-26">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/amenagements-exterieurs/bois-amenagement-exterieur.html"
                                                      >
                                                        <span>
                                                          Bois pour aménagement
                                                          extérieur
                                                        </span>
                                                      </a>
                                                    </li>
                                                    <li className="level2 no-child nav-3-9-27 last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/amenagements-exterieurs/accessoires.html"
                                                      >
                                                        <span>Accessoires</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                              <li className="level1 groups item nav-3-10 last">
                                                <a
                                                  className="title-group"
                                                  href="https://www.rullier.fr/terrasse-et-exterieurs/entretien-et-finition.html"
                                                >
                                                  <span>Entretien et finition</span>
                                                </a>
                                                <div className="groups-wrapper">
                                                  <ul className="level1">
                                                    <li className="level2 no-child nav-3-10-28 first last">
                                                      <a
                                                        className=""
                                                        href="https://www.rullier.fr/terrasse-et-exterieurs/entretien-et-finition/produits.html"
                                                      >
                                                        <span>Produits</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div>
                                            <img
                                              width="100%"
                                              src="https://www.rullier.fr/media/catalog/product/cache/1/small_image/270x330/9df78eab33525d08d6e5fb8d27136e95/s/a/sans_titre_1.png"
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <label>Item 3</label>
                          </li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                  <span>
                    <img
                      height={70}
                      src="/assets/images/logo-rullier-bois.png"
                      alt=""
                    />
                  </span>
                  {/* </a> */}
                </div>
              </div>
              <button
                className="navbar-toggler p-2 rounded-0"
                type="button"
                data-bs-toggle="offcanvas"
                href="#mobileDrawer"
                role="button"
                aria-controls="mobileDrawer"
              >
                <span className="navbar-togger-icon py-3">
                  <svg
                    width={38}
                    height={20}
                    viewBox="0 0 38 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={38} height={3} fill="#B39C81" />
                    <rect y={13} width={38} height={3} fill="#B39C81" />
                    <rect y={26} width={38} height={3} fill="#B39C81" />
                  </svg>
                </span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <div className="search-bar flex-grow-1">
                  <form action="#">
                    <div className="grouped-search">
                      <button className="btn-search btn">
                        <svg
                          width={18}
                          height={18}
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx={8}
                            cy={8}
                            r="7.25"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M13.5 13.5L16.5 16.5"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                      <input
                        className="form-control border-primary form-control-lg"
                        type="text"
                        placeholder="Que recherchez-vous?"
                        aria-label=".form-control-lg example"
                      />
                    </div>
                  </form>
                </div>
                <ul className="navbar-nav">
                  <li className="nav-item me-3">
                    <a className="nav-link active" aria-current="page" href="#">
                      <span className="d-flex">
                        <span className="me-2 icon">
                          <svg
                            width={21}
                            height={23}
                            viewBox="0 0 21 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15.94 21.8241C16.6686 21.8241 17.3971 21.8239 18.1257 21.8237C18.9725 21.8232 19.6307 21.3176 19.7636 20.5656C19.8263 20.2099 19.7977 19.8419 19.7576 19.4972C19.6085 18.2191 19.0801 17.096 18.1866 16.1592C16.9942 14.9089 15.4939 14.2728 13.7267 14.2686C12.909 14.2668 12.0565 14.2659 11.1206 14.2659C9.7857 14.2659 8.48176 14.2677 7.38238 14.2697C7.05202 14.2701 6.76596 14.2849 6.50725 14.3146C5.21261 14.4631 4.07659 14.9794 3.13072 15.849C1.94875 16.9359 1.29952 18.3073 1.20143 19.9252C1.18356 20.2173 1.20854 20.4809 1.27545 20.709C1.47691 21.3958 2.08896 21.823 2.87274 21.8233C4.04213 21.8239 5.2117 21.8241 6.38127 21.8241L10.2845 21.8239L15.94 21.8241ZM6.00807 23.0001C4.95554 23.0001 3.9032 22.9999 2.8505 22.999C1.47418 22.9979 0.353652 22.1089 0.0623072 20.7871C-0.0292165 20.3717 -0.00387426 19.9464 0.036965 19.5487C0.193212 18.0313 0.769519 16.694 1.75003 15.5746C2.94002 14.2157 4.45727 13.4036 6.25948 13.1608C6.58182 13.1174 6.93315 13.0957 7.33389 13.0948C7.82578 13.0936 8.31767 13.0916 8.80957 13.0896C9.60739 13.0865 10.4322 13.0833 11.2433 13.0833C12.2592 13.0833 13.1052 13.0881 13.9065 13.099C14.7468 13.1102 15.5665 13.2622 16.3431 13.5503C17.099 13.8307 17.7968 14.2336 18.4165 14.7475C19.0356 15.2608 19.5598 15.8705 19.9742 16.5599C20.3992 17.2668 20.6982 18.0403 20.863 18.8586C20.9933 19.5068 21.0294 20.0418 20.9766 20.5427C20.8528 21.7122 19.9578 22.6937 18.8001 22.9292C18.5827 22.9735 18.3488 22.9961 18.1045 22.9966C16.5672 22.9997 15.0299 23.0001 13.8622 23.0001C13.2767 23.0001 10.2796 22.9997 10.2796 22.9997C9.56765 22.9997 6.72002 23.0001 6.00807 23.0001V23.0001Z"
                              fill="#B39C81"
                            />
                            <mask
                              id="mask0_0_10432"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x={4}
                              y={0}
                              width={13}
                              height={13}
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.4082 0H16.5931V12.0878H4.4082V0Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask0_0_10432)">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.4969 1.17606C9.18658 1.17859 7.9552 1.68615 7.02957 2.60529C6.10413 3.52425 5.59437 4.7458 5.59418 6.04435C5.59418 7.34362 6.10467 8.56571 7.0314 9.4854C7.95794 10.4053 9.18895 10.9117 10.4976 10.9117H10.5108C11.8213 10.9083 13.0526 10.3989 13.9783 9.47745C14.9041 8.55577 15.4115 7.33404 15.4069 6.03748C15.4024 4.73821 14.8906 3.5172 13.9655 2.59951C13.0404 1.68145 11.8121 1.17606 10.5071 1.17606H10.4969ZM10.5064 12.0877C8.87536 12.0877 7.34334 11.4587 6.19255 10.3165C5.04158 9.1745 4.40784 7.65416 4.4082 6.03568C4.40857 4.42821 5.04304 2.91384 6.19474 1.77128C7.34644 0.629089 8.87226 -0.00012207 10.4918 -0.00012207H10.5027C12.1323 0.00277002 13.6623 0.633246 14.8113 1.77526C15.9602 2.9171 16.5931 4.43653 16.5931 6.05339C16.5931 9.37821 13.8647 12.0852 10.5108 12.0877H10.5064Z"
                                fill="#B39C81"
                              />
                            </g>
                          </svg>
                        </span>
                        <span>Mon compte</span>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="#">
                      <span className="d-flex">
                        <span className="me-2 icon">
                          <svg
                            width={23}
                            height={22}
                            viewBox="0 0 23 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.609 17.8689H4.71795C4.47222 17.8689 4.27564 17.7693 4.17735 17.5697C4.02991 17.3711 4.02991 17.1222 4.12821 16.9232L5.40598 13.6381L4.12821 1.39367H0V0H4.71795C5.06197 0 5.35684 0.24887 5.40598 0.597288L6.78205 13.5878C6.78205 13.6878 6.78205 13.7874 6.73291 13.9367L5.75 16.4254H19.609V17.8689"
                              fill="#B39C81"
                            />
                            <mask
                              id="mask0_0_10443"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x={5}
                              y={2}
                              width={18}
                              height={13}
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5.40625 2.78711H23.0004V14.4342H5.40625V2.78711Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask0_0_10443)">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.24172 14.4342L5.94685 13.0903L21.6242 9.80524V4.18078H5.40625V2.78711H22.3122C22.7054 2.78711 23.0008 3.08575 23.0008 3.48395V10.3528C23.0008 10.7012 22.755 10.95 22.4597 10.9998L6.24172 14.4342"
                                fill="#B39C81"
                              />
                            </g>
                            <mask
                              id="mask1_0_10443"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x={17}
                              y={16}
                              width={6}
                              height={6}
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M17.5938 16.5249H22.9995V21.9999H17.5938V16.5249Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask1_0_10443)">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M20.2967 17.8688C19.5596 17.8688 18.9202 18.4661 18.9202 19.2625C18.9202 20.0584 19.5099 20.6561 20.2967 20.6561C21.0831 20.6561 21.6728 20.0584 21.6728 19.2625C21.6728 18.4661 21.0339 17.8688 20.2967 17.8688M20.2967 22C18.8224 22 17.5938 20.7557 17.5938 19.2625C17.5938 17.7693 18.8224 16.5249 20.2967 16.5249C21.7711 16.5249 22.9997 17.7693 22.9997 19.2625C22.9997 20.7557 21.7711 22 20.2967 22"
                                fill="#B39C81"
                              />
                            </g>
                            <mask
                              id="mask2_0_10443"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x={1}
                              y={16}
                              width={6}
                              height={6}
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1.37598 16.5249H6.78196V21.9999H1.37598V16.5249Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask2_0_10443)">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.07897 17.8688C3.34179 17.8688 2.7029 18.4661 2.7029 19.2625C2.7029 20.0584 3.29264 20.6561 4.07897 20.6561C4.86529 20.6561 5.45504 20.0584 5.45504 19.2625C5.45504 18.4661 4.81615 17.8688 4.07897 17.8688M4.07897 22C2.60461 22 1.37598 20.7557 1.37598 19.2625C1.37598 17.7693 2.60461 16.5249 4.07897 16.5249C5.55333 16.5249 6.78196 17.7693 6.78196 19.2625C6.78196 20.7557 5.55333 22 4.07897 22"
                                fill="#B39C81"
                              />
                            </g>
                          </svg>
                        </span>
                        <span>Mon panier</span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="container nav-2 py-3">
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                  <li className="nav-item me-3">
                    <a className="nav-link active" aria-current="page" href="#">
                      <span className="d-flex">
                        <span> Produits</span>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="#">
                      <span className="d-flex">
                        <span>Services</span>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="#">
                      <span className="d-flex">
                        <span>Projet 1 clic</span>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link btn btn-secondary mt-1 px-2 py-1"
                      aria-current="page"
                      href="#"
                    >
                      <span className="d-flex">
                        <span>Bonnes affaires</span>
                      </span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link btn btn-primary mt-1 px-2 py-1"
                      aria-current="page"
                      href="#"
                    >
                      <span className="d-flex">
                        <span>Médias</span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          {/* Mobile menu */}
          <div
            className="offcanvas offcanvas-start mobile-menu"
            tabIndex={-1}
            id="mobileDrawer"
            aria-labelledby="mobileDrawerLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="mobileDrawerLabel">
                <a href="#">
                  <span>
                    <img
                      height={70}
                      src="/assets/images/logo-rullier-bois.png"
                      alt=""
                    />
                  </span>
                </a>
                {/* <strong>MENU</strong> */}
              </h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="px-3">
              <hr className="my-0" />
            </div>
            <div className="offcanvas-body">
              <ul className="nav flex-column">
                <li className="nav-item">
                  <a className="nav-link active" aria-current="page" href="#">
                    <span className="d-flex">
                      <span className="me-2 icon">
                        <svg
                          width={21}
                          height={23}
                          viewBox="0 0 21 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.94 21.8241C16.6686 21.8241 17.3971 21.8239 18.1257 21.8237C18.9725 21.8232 19.6307 21.3176 19.7636 20.5656C19.8263 20.2099 19.7977 19.8419 19.7576 19.4972C19.6085 18.2191 19.0801 17.096 18.1866 16.1592C16.9942 14.9089 15.4939 14.2728 13.7267 14.2686C12.909 14.2668 12.0565 14.2659 11.1206 14.2659C9.7857 14.2659 8.48176 14.2677 7.38238 14.2697C7.05202 14.2701 6.76596 14.2849 6.50725 14.3146C5.21261 14.4631 4.07659 14.9794 3.13072 15.849C1.94875 16.9359 1.29952 18.3073 1.20143 19.9252C1.18356 20.2173 1.20854 20.4809 1.27545 20.709C1.47691 21.3958 2.08896 21.823 2.87274 21.8233C4.04213 21.8239 5.2117 21.8241 6.38127 21.8241L10.2845 21.8239L15.94 21.8241ZM6.00807 23.0001C4.95554 23.0001 3.9032 22.9999 2.8505 22.999C1.47418 22.9979 0.353652 22.1089 0.0623072 20.7871C-0.0292165 20.3717 -0.00387426 19.9464 0.036965 19.5487C0.193212 18.0313 0.769519 16.694 1.75003 15.5746C2.94002 14.2157 4.45727 13.4036 6.25948 13.1608C6.58182 13.1174 6.93315 13.0957 7.33389 13.0948C7.82578 13.0936 8.31767 13.0916 8.80957 13.0896C9.60739 13.0865 10.4322 13.0833 11.2433 13.0833C12.2592 13.0833 13.1052 13.0881 13.9065 13.099C14.7468 13.1102 15.5665 13.2622 16.3431 13.5503C17.099 13.8307 17.7968 14.2336 18.4165 14.7475C19.0356 15.2608 19.5598 15.8705 19.9742 16.5599C20.3992 17.2668 20.6982 18.0403 20.863 18.8586C20.9933 19.5068 21.0294 20.0418 20.9766 20.5427C20.8528 21.7122 19.9578 22.6937 18.8001 22.9292C18.5827 22.9735 18.3488 22.9961 18.1045 22.9966C16.5672 22.9997 15.0299 23.0001 13.8622 23.0001C13.2767 23.0001 10.2796 22.9997 10.2796 22.9997C9.56765 22.9997 6.72002 23.0001 6.00807 23.0001V23.0001Z"
                            fill="#B39C81"
                          />
                          <mask
                            id="mask0_0_10432"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x={4}
                            y={0}
                            width={13}
                            height={13}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.4082 0H16.5931V12.0878H4.4082V0Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask0_0_10432)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.4969 1.17606C9.18658 1.17859 7.9552 1.68615 7.02957 2.60529C6.10413 3.52425 5.59437 4.7458 5.59418 6.04435C5.59418 7.34362 6.10467 8.56571 7.0314 9.4854C7.95794 10.4053 9.18895 10.9117 10.4976 10.9117H10.5108C11.8213 10.9083 13.0526 10.3989 13.9783 9.47745C14.9041 8.55577 15.4115 7.33404 15.4069 6.03748C15.4024 4.73821 14.8906 3.5172 13.9655 2.59951C13.0404 1.68145 11.8121 1.17606 10.5071 1.17606H10.4969ZM10.5064 12.0877C8.87536 12.0877 7.34334 11.4587 6.19255 10.3165C5.04158 9.1745 4.40784 7.65416 4.4082 6.03568C4.40857 4.42821 5.04304 2.91384 6.19474 1.77128C7.34644 0.629089 8.87226 -0.00012207 10.4918 -0.00012207H10.5027C12.1323 0.00277002 13.6623 0.633246 14.8113 1.77526C15.9602 2.9171 16.5931 4.43653 16.5931 6.05339C16.5931 9.37821 13.8647 12.0852 10.5108 12.0877H10.5064Z"
                              fill="#B39C81"
                            />
                          </g>
                        </svg>
                      </span>
                      <span>Mon compte</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" aria-current="page" href="#">
                    <span className="d-flex">
                      <span className="me-2 icon">
                        <svg
                          width={23}
                          height={22}
                          viewBox="0 0 23 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.609 17.8689H4.71795C4.47222 17.8689 4.27564 17.7693 4.17735 17.5697C4.02991 17.3711 4.02991 17.1222 4.12821 16.9232L5.40598 13.6381L4.12821 1.39367H0V0H4.71795C5.06197 0 5.35684 0.24887 5.40598 0.597288L6.78205 13.5878C6.78205 13.6878 6.78205 13.7874 6.73291 13.9367L5.75 16.4254H19.609V17.8689"
                            fill="#B39C81"
                          />
                          <mask
                            id="mask0_0_10443"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x={5}
                            y={2}
                            width={18}
                            height={13}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M5.40625 2.78711H23.0004V14.4342H5.40625V2.78711Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask0_0_10443)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M6.24172 14.4342L5.94685 13.0903L21.6242 9.80524V4.18078H5.40625V2.78711H22.3122C22.7054 2.78711 23.0008 3.08575 23.0008 3.48395V10.3528C23.0008 10.7012 22.755 10.95 22.4597 10.9998L6.24172 14.4342"
                              fill="#B39C81"
                            />
                          </g>
                          <mask
                            id="mask1_0_10443"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x={17}
                            y={16}
                            width={6}
                            height={6}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M17.5938 16.5249H22.9995V21.9999H17.5938V16.5249Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask1_0_10443)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M20.2967 17.8688C19.5596 17.8688 18.9202 18.4661 18.9202 19.2625C18.9202 20.0584 19.5099 20.6561 20.2967 20.6561C21.0831 20.6561 21.6728 20.0584 21.6728 19.2625C21.6728 18.4661 21.0339 17.8688 20.2967 17.8688M20.2967 22C18.8224 22 17.5938 20.7557 17.5938 19.2625C17.5938 17.7693 18.8224 16.5249 20.2967 16.5249C21.7711 16.5249 22.9997 17.7693 22.9997 19.2625C22.9997 20.7557 21.7711 22 20.2967 22"
                              fill="#B39C81"
                            />
                          </g>
                          <mask
                            id="mask2_0_10443"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x={1}
                            y={16}
                            width={6}
                            height={6}
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1.37598 16.5249H6.78196V21.9999H1.37598V16.5249Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask2_0_10443)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.07897 17.8688C3.34179 17.8688 2.7029 18.4661 2.7029 19.2625C2.7029 20.0584 3.29264 20.6561 4.07897 20.6561C4.86529 20.6561 5.45504 20.0584 5.45504 19.2625C5.45504 18.4661 4.81615 17.8688 4.07897 17.8688M4.07897 22C2.60461 22 1.37598 20.7557 1.37598 19.2625C1.37598 17.7693 2.60461 16.5249 4.07897 16.5249C5.55333 16.5249 6.78196 17.7693 6.78196 19.2625C6.78196 20.7557 5.55333 22 4.07897 22"
                              fill="#B39C81"
                            />
                          </g>
                        </svg>
                      </span>
                      <span>Mon panier</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <hr />
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-upper text-bold active"
                    aria-current="page"
                    href="#"
                  >
                    <span className="d-flex">
                      <span> Produits</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-upper text-bold"
                    aria-current="page"
                    href="#"
                  >
                    <span className="d-flex">
                      <span>Services</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-upper text-bold"
                    aria-current="page"
                    href="#"
                  >
                    <span className="d-flex">
                      <span>Projet 1 clic</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <hr />
                </li>
                <li className="nav-item mb-3">
                  <a
                    className="nav-link text-upper text-bold btn btn-secondary px-4"
                    aria-current="page"
                    href="#"
                  >
                    <span className="d-flex">
                      <span>Bonnes affaires</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item mb-3">
                  <a
                    className="nav-link text-upper text-bold btn btn-primary px-4"
                    aria-current="page"
                    href="#"
                  >
                    <span className="d-flex">
                      <span>Médias</span>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <hr />
                </li>
                {/* <li class="nav-item">
                            <a href="#" class="nav-link">Notre Histoire</a>
                          </li>
                          <li class="nav-item">
                            <a href="#" class="nav-link">Nos Valeurs</a>
                          </li> */}
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    Nous contacter
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    Nous rejoindre
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header >

  )
}

export default Header